export default __webpack_public_path__ + "static/media/BILLETERA_ICON_ORG_23.43beb725.png";